// extracted by mini-css-extract-plugin
export default {"login":"login_login__UCiq6","login__logo":"login_login__logo__BThmI","login__cta":"login_login__cta__EX1m0","login__legal":"login_login__legal__TRwtd"};